// extracted by mini-css-extract-plugin
export default {"faqModal":"FAQModal_faqModal__ZDHuc","closeBtn":"FAQModal_closeBtn__wB9ZE","faqItem":"FAQModal_faqItem__whJHf","scaleIn":"FAQModal_scaleIn__K9s+K"};